import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  PlaybookTrackerFilterOptions,
  PlaybookTrackerRow,
  PlaybookTrackerState,
} from './types';

const defaultFilterOptions: PlaybookTrackerFilterOptions = {
  envs: [],
  clients: [],
  leadIds: [],
  playbookCodes: [],
  statuses: [],
};

const initialState: PlaybookTrackerState = {
  loading: false,
  error: null,
  rows: [],
  total: 0,
  filterOptions: { ...defaultFilterOptions },
};

export const playbookTrackerSlice = createSlice({
  name: 'playbookTracker',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;

      if (action.payload) {
        state.rows = [];
        state.total = 0;
      }
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    setResults(
      state,
      action: PayloadAction<{
        rows: PlaybookTrackerRow[];
        total: number;
        filterOptions: PlaybookTrackerFilterOptions;
      }>,
    ) {
      state.rows = action.payload.rows;
      state.total = action.payload.total;
      state.filterOptions = action.payload.filterOptions;
      state.error = null;
    },

    clearState(state) {
      state.loading = false;
      state.error = null;
      state.rows = [];
      state.total = 0;
      state.filterOptions = { ...defaultFilterOptions };
    },
  },
});

export const { clearState, setError, setLoading, setResults } =
  playbookTrackerSlice.actions;

const reducer = { playbookTracker: playbookTrackerSlice.reducer };

export default reducer;
